export const findTypeLabel = (v) => {
  if (v === "self_drive") {
    return "Self Drive";
  } else if (v === "transfer_service") {
    return "Transfer Service";
  } else if (v === "tour") {
    return "Tour / Daily Charter";
  } else {
    return "Default";
  }
};
